import { Button } from "@/components/primitives/button";
import { Trash2 } from "lucide-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "./Spinner";

interface FileUploaderProps {
  isUploading: boolean;
  attachmentId: string | null;
  filename: string | null;
  deleteFile: () => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export default function FileUploader({
  isUploading,
  attachmentId,
  filename,
  deleteFile,
  handleFileChange,
}: FileUploaderProps) {
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);

  function handleOpenFileDialog() {
    if (!fileInputRef.current) {
      return;
    }
    fileInputRef.current.click();
  }

  return (
    <div className="relative flex flex-col items-center justify-center">
      <input
        type="file"
        accept="image/png, image/gif, image/jpeg, image/jpg, image/webp, video/*"
        ref={fileInputRef}
        onChange={(e) => handleFileChange(e)}
        className="hidden"
      />
      {isUploading && <Spinner />}

      {attachmentId && (
        <p className="flex cursor-pointer items-center gap-2 text-sm text-gray-400">
          {t("fileAdded", { filename: filename })}
          <Trash2
            className="ml-4 cursor-pointer hover:text-red-500"
            onClick={deleteFile}
          />
        </p>
      )}

      {!attachmentId && (
        <Button
          type="button"
          variant="link"
          className="self-center hover:no-underline"
          onClick={handleOpenFileDialog}
        >
          {t("uploadFile")}
        </Button>
      )}
    </div>
  );
}
